export const MISSING_ORG_URL = __DEV__
  ? "https://churchcenter.test/missing_organization"
  : "https://churchcenter.com/missing_organization"
